import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "../../Styles/ViewExamination.css";
import CancelIcon from "@mui/icons-material/Cancel";
import Loader from "../../Components/Loader";
import { Link } from "react-router-dom";

function ViewExaminationHistory() {
    const [exams, setExams] = useState([]);
    const [selectedExam, setSelectedExam] = useState(null);
    const [remark, setRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchExams = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                const response = await axios.get("https://api.uniums.com/api/exam/exam-history", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const examsWithCancelStatus = response.data.map((exam) => ({
                    ...exam,
                    isCanceled: !!exam.remark,
                }));

                setExams(examsWithCancelStatus);
            } catch (error) {
                console.error("Error fetching exams:", error);
                toast.error("Failed to fetch exams.");
            } finally {
                setLoading(false);
            }
        };

        fetchExams();
    }, []);

    const handleCancelClick = (exam) => {
        setSelectedExam(exam);
        setShowModal(true);
    };

    const handleRemarkSubmit = async () => {
        try {
            const token = localStorage.getItem("authToken");
            await axios.post(
                `https://api.uniums.com/api/exam/cancel-exam/${selectedExam._id}`,
                { remark },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            toast.success("Exam canceled successfully!");
            setExams((prevExams) =>
                prevExams.map((exam) =>
                    exam._id === selectedExam._id ? { ...exam, isCanceled: true, remark } : exam
                )
            );
        } catch (error) {
            console.error("Error canceling exam:", error);
            toast.error("Failed to cancel exam.");
        } finally {
            setShowModal(false);
            setRemark("");
        }
    };




    return (
        <div className="view-examination-container">
            <ToastContainer />
            {loading && <Loader />}
            <h1>Exam History</h1>
            <Link to={'/view-examination'}>
                <p className='link_text'>Back To Exam </p>
            </Link>
            <div className="exam-cards">
                {exams.length === 0 && !loading ? (
                    <p className="no-data-message">No data found</p>
                ) : (
                    exams.map((exam) => (
                        <div
                            className={`exam-card ${exam.isCanceled ? "canceled-card" : ""}`}
                            key={exam._id}
                        >
                            <div className={`card-header ${exam.isCanceled ? "canceled-header" : ""}`}>
                                {exam.isCanceled && <p>Exam Canceled</p>}
                            </div>
                            <h2>Test Name: {exam.examName}</h2>
                            <p>
                                <strong>Date:</strong>{" "}
                                {new Date(exam.examDate).toLocaleDateString()}
                            </p>
                            <p>
                                <strong>Time: </strong>
                                {exam.examTime || "N/A"}
                            </p>
                            <p>
                                <strong>Class:</strong> {exam.className}
                            </p>
                            <p>
                                <strong>Subjects:</strong>
                            </p>
                            <ul>
                                {exam.subjects.map((subject) => (
                                    <li key={subject.subject}>
                                        {subject.subject} - {subject.questionType} ({subject.totalMarks} marks)
                                    </li>
                                ))}
                            </ul>
                            <p>
                                <strong>Details:</strong>{" "}
                                {exam.examDetails ? exam.examDetails : "No details available"}{" "}
                            </p>
                            {exam.isCanceled && (
                                <p className="remark_color">
                                    <strong>Remark:</strong> {exam.remark}
                                </p>
                            )}
                            {!exam.isCanceled ? (
                                <button
                                    className="cancel_button_exam"
                                    onClick={() => handleCancelClick(exam)}
                                >
                                    <CancelIcon /> Cancel
                                </button>
                            ) : (
                                <p className="canceled-message">Exam was canceled</p>
                            )}
                            <p className="download_btn_p">
                                {exam.documentDetails ? (
                                    <a href={exam.documentDetails} download>Download File </a>
                                ) : (
                                    "Document Not Available"
                                )}
                            </p>


                        </div>
                    ))
                )}
            </div>

            {showModal && (
                <div className="custom-modal">
                    <div className="modal-content-exam">
                        <h2>Cancel Exam</h2>
                        <p>
                            Are you sure you want to cancel the exam{" "}
                            <strong>{selectedExam.examName}</strong>?
                        </p>
                        <textarea
                            className="remark_input_exam"
                            placeholder="Enter your remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                        <div className="modal_actions_exam">
                            <button className="submit_button_exam" onClick={handleRemarkSubmit}>
                                Submit
                            </button>
                            <button
                                className="close_button_exam"
                                onClick={() => setShowModal(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ViewExaminationHistory;
